import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MeldungsEmpfaengerSearchRequest } from '../../../core/grundbuchmeldung-api';
import { Ech0134ModuleStateData } from '../../ech0134-module-state-data';
import { ActivatedRoute, Router } from '@angular/router';
import { simplify } from '../../../shared/functions/meta.functions';
import { FormsModule } from '@angular/forms';
import { CapFormColumnsDirective } from '../../../shared/form-control/form-columns.directive';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../../shared/components/title-functionbar/title-functionbar.component';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { CapFormRowDirective } from '../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../shared/form-control/form-control.component';
import { AutofocusDirective } from '../../../shared/directives/autofocus.directive';
import { MetaDisablerDirective } from '../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../shared/directives/meta-validator.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { CapActionbarComponent } from '../../../core/extension/actionbar/actionbar.component';

@Component({
  selector: 'cap-meldungsempfaenger-suche',
  templateUrl: './meldungsempfaenger-suche.component.html',
  styleUrls: ['./meldungsempfaenger-suche.component.scss'],
  imports: [
    FormsModule,
    CapFormColumnsDirective,
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    NgbNav,
    NgbNavItem,
    NgbNavItemRole,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    CapFormRowDirective,
    CapFormControlComponent,
    AutofocusDirective,
    MetaDisablerDirective,
    MetaValidatorDirective,
    TranslatePipe,
    NgbNavOutlet,
    CapActionbarComponent
  ]
})
export class MeldungsempfaengerSucheComponent implements OnInit {
  @ViewChild('bezeichnungInput', { static: false })
  private bezeichnungInput: ElementRef;

  private searchRequest: MeldungsEmpfaengerSearchRequest;

  constructor(
    private moduleStateData: Ech0134ModuleStateData,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.searchRequest = this.moduleStateData.lastEmpfaengerSearchRequest || {};
  }

  onSubmit() {
    this.router.navigate(['../list'], {
      relativeTo: this.route,
      queryParams: { request: JSON.stringify(simplify(this.searchRequest)) }
    });
  }

  onReset() {
    this.searchRequest = {};
    if (this.bezeichnungInput) {
      this.bezeichnungInput.nativeElement.focus();
    }
  }

  onNew() {
    this.router.navigate(['../new'], {
      relativeTo: this.route
    });
  }
}
